export interface POrdersDto {
  id: number;
  companyNo: string;
  orderNo: number;
  orderNoERP: string;
  orderStatus: number;
  orderType?: string;
  orderStatusERP?: string;
  orderDate?: Date;
  deliveryDate?: Date;
  supplierNo: string;
  supplierName?: string;
  delAddressNo?: number;
  delCustomerName?: string;
  delAddress1?: string;
  delAddress2?: string;
  delAddress3?: string;
  delZipCode?: string;
  delCity?: string;
  delCountryCode?: string;
  deliveryGLN?: string;
  supplierOrderNo?: string;
  yourRef?: string;
  ourRef?: string;
  deliveryMethod?: string;
  temsOfDelivery?: string;
  shipmentType?: string;
  carrierName?: string;
  contactName?: string;
  eMailAddress?: string;
  orderFreeField1?: string;
  orderFreeField2?: string;
  orderFreeField3?: string;
  warehouse?: string;
  projectNo?: string;
  depNo?: string;
  systemStatus?: number;
  created?: Date;
  lastUpdate?: Date;
  createdBy?: string;
  updatedBy?: string;
  statusText?: string;
  numOfLines?: number;
}

export interface POrdersListItem {
  id: number;
  orderNoERP: string;
  orderStatus: number;
  delCustomerName?: string;
  supplierName?: string;
  orderDate?: string;
  warehouse?: string;
  statusText?: string;
}

export enum POrderStatus {
  Ubehandlet = 0,
  Godkjent = 10,
  UnderArbeid = 20,
  BehandletIkkeKomplett = 30,
  BehandletKomplett = 40,
  TilPakking = 45,
  KlarForEksport = 50,
  Eksportert = 60
}

export interface POrderLineDto {
  id: number;
  companyNo: string;
  orderNo: number;
  lineNo: number;
  lineNoERP?: number;
  lineStatus: number;
  itemNo: string;
  itemBarCode?: string;
  description1?: string;
  itemGroup1?: string;
  itemGroup2?: string;
  itemGroup3?: string;
  quantity?: number;
  quantityDelivered?: number;
  itemUnitCode?: string;
  itemUnitTxt?: string;
  price?: number;
  discount?: number;
  deliveryDate?: Date;
  serialNoItemYesNo?: boolean;
  stdLocationName?: string;
  warehouse?: string;
  orderNoERP?: string;
  quantityDeliveredOnClient?: number;
  quantityReserved?: number;
  quantityAvailable?: number;
  systemStatus?: number;
  externalSystemID?: number;
  externalSystemStatus?: number;
  itemBatchNo?: string;
  batchItemYesNo?: boolean;
  orderLineFreeField1?: string;
  orderLineFreeField2?: string;
  orderLineFreeField3?: string;
  /** Inbound shipment reference for grouping PO lines from the same shipment/container */
  inboundShipmentNo?: string;
  /** Beregnet (Lag 1): finnes ItemNo i Items-master? Brukes til proaktiv gating av aktiv linje. Default true. */
  itemExistsInMaster?: boolean;
  created?: Date;
  lastUpdate?: Date;
  createdBy?: string;
  updatedBy?: string;
  statusText?: string;
  remainingQuantity?: number;
}

export interface POrderDetailsDto {
  header: POrdersDto;
  lines: POrderLineDto[];
  totalLines: number;
  totalQuantity: number;
  totalDelivered: number;
  completionPercentage: number;
}

export interface POrderStatisticsDto {
  totalOrders: number;
  pendingOrders: number;
  completedOrders: number;
  completionPercentage: number;
}

// ========== Inbound Shipment Types (Modus 3) ==========

/**
 * Summary DTO for inbound shipments, aggregating data from POrderLines
 * with the same InboundShipmentNo. Used for displaying shipment list in Modus 3.
 */
export interface InboundShipmentSummaryDto {
  /** The inbound shipment identifier (e.g., container number, shipment reference) */
  inboundShipmentNo: string;
  /** Comma-separated list of unique supplier numbers in this shipment */
  supplierNos: string;
  /** Comma-separated list of unique supplier names in this shipment */
  supplierNames: string;
  /** Total number of PO lines in this shipment */
  lineCount: number;
  /** Number of distinct purchase orders in this shipment */
  orderCount: number;
  /** Total expected quantity across all lines */
  totalQuantity: number;
  /** Total quantity already delivered across all lines */
  totalDelivered: number;
  /** Remaining quantity to receive (TotalQuantity - TotalDelivered) */
  remainingQuantity: number;
  /** Earliest delivery date among all lines */
  earliestDeliveryDate?: Date;
  /** Warehouse code (if all lines share the same warehouse) */
  warehouse?: string;
  /** Completion percentage (TotalDelivered / TotalQuantity * 100) */
  completionPercentage: number;
}
